// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__TF3nv","image":"Header_image__2r8cF","name":"Header_name__3L4bz","info":"Header_info__2foSb","infoRow":"Header_infoRow__3WmFh"};